import pairedMap from './pairedMap';

export default (features = {}) =>
  pairedMap(([key, value]) => [key, value === true], features);
